module.exports = __webpack_public_path__ + "0dd28e2b1c71305b7714499929ca05f4.MP3";